import { AddressInput } from '@commenda/kakashi';
import { IAddress } from '@commenda/types';
import { Country } from '@prisma/client';
import { MoleculeCard } from '../helpers/MoleculeCard';
import { MoleculeCardTitle } from '../helpers/MoleculeCardTitle';

type EntityRegisteredAddressInputProps = {
  address: IAddress;
  onAddressChange: (address: IAddress) => void;
  disabled?: boolean;
  error?: Partial<Record<keyof IAddress, string | undefined>>;
  defaultCountry?: Country;
  onClearError?: (field: keyof IAddress) => void;
};

export function EntityRegisteredAddressInput({
  address,
  onAddressChange,
  disabled = false,
  error,
  defaultCountry,
  onClearError,
}: EntityRegisteredAddressInputProps) {
  // Get the current registered address from the selected entity or use an empty address
  const registeredAddress = address || {
    addressLine1: '',
    addressLine2: '',
    postalCode: '',
    city: '',
    state: '',
    country: defaultCountry || '',
  };

  return (
    <MoleculeCard>
      <MoleculeCardTitle title="Registered address" />
      <AddressInput
        id="entity-registered-address"
        address={registeredAddress}
        onChange={onAddressChange}
        disabled={disabled}
        error={error}
        defaultCountry={defaultCountry}
        onClearError={onClearError}
      />
    </MoleculeCard>
  );
}
